/**
 * 必須チェック
 * @param value
 * @returns {string}
 */
export const isRequired = (value) => {
    const msg = '必須です。';
    const validateList = [
        (v) => v === null || v === undefined,
        (v) => Array.isArray(v) && v.length === 0,
        (v) => typeof v === 'object' && v !== null && Object.keys(v).length === 0,
        (v) => typeof v === 'string' && v.trim().length === 0,
    ];
    return validateList.some((func) => func(value)) ? msg : '';
};
/**
 * 必須チェック＋テキスト指定
 * @param text
 * @returns {function(*=): string}
 */
export const isRequiredText = (text) => (value) => isRequired(value) ? text : '';
